import {z} from 'zod'

export const recommendationSourceTypes = ['ical', 'github-commit', 'jira-issue'] as const
export const RecommendationSourceType = z.enum(recommendationSourceTypes)
export type RecommendationSourceType = (typeof recommendationSourceTypes)[number]
